module.exports = __webpack_public_path__ + "media/0004.634ced45.mp3";